import { LogoutOptions, RedirectLoginOptions } from "@auth0/auth0-react";
import { ItineraryAccommodation, ItineraryActivity, ItineraryCarRental, ItineraryCruise, ItineraryFerry, ItineraryFlight, ItineraryRestaurant, ItineraryTrain, ItineraryTransfer, SortedItem, UserProfile } from "../Types";
import moment from "moment";
import { DateTime } from "luxon";


export const HandleLogin = async (loginWithRedirect: (options?: RedirectLoginOptions | undefined) => Promise<void>, logout: (options?: LogoutOptions | undefined) => void, isAuthenticated: boolean) => {

    if (window.location.pathname === '/viewer/login' || (!isAuthenticated && window.location.pathname === '/viewer/')) {


        return await loginWithRedirect({
            appState: {
                returnTo: '/viewer/'
            }
        });
    } else if (window.location.pathname === '/viewer/signup') {


        return await loginWithRedirect({
            screen_hint: 'signup',
            appState: {
                returnTo: '/viewer'
            }
        });
    } else if (window.location.pathname === '/viewer/signout') {
        return await logout({ returnTo: window.location.origin + '/viewer/' });
    }
};


export function keyExistInObject(data: UserProfile, type: string) {
    if (type === '')
        return data
    else
        return data[type as keyof typeof data]!
}

export function isFlight(fli: SortedItem): fli is ItineraryFlight {
    return fli.type === 'flight'
}
export function isTrain(fli: SortedItem): fli is ItineraryTrain {
    return fli.type === 'train'
}
export function isFerry(fli: SortedItem): fli is ItineraryFerry {
    return fli.type === 'ferry'
}
export function isTransfer(fli: SortedItem): fli is ItineraryTransfer {
    return fli.type === 'transfer'
}
export function isRestaurant(fli: SortedItem): fli is ItineraryRestaurant {
    return fli.type === 'Restaurant'
}
export function isCarRental(fli: SortedItem): fli is ItineraryCarRental {
    return fli.type === 'carRental'
}
export function isActivity(fli: SortedItem): fli is ItineraryActivity {
    return fli.type === 'activity'
}
export function isAccommodation(fli: SortedItem): fli is ItineraryAccommodation {
    return fli.type === 'accommodation'
}
export function isCruise(fli: SortedItem): fli is ItineraryCruise {
    return fli.type === 'cruises'
}

export const checkSpacing = (node: string | null) => {
    let text: string
    if (node !== null) {
        text = node
        text = text?.replaceAll("&nbsp;", "");
        text = text?.replace(/<[^>]+>/g, "");
        if (text?.trim() === "") {
            return false
        } else {
            return true
        }
    }
    else return false
}

export const Time = (timeVal: string) => {
    let dateString = timeVal
    let dateObj = new Date(dateString);
    let hours = dateObj.getUTCHours();
    let minutes = dateObj.getUTCMinutes();
    let amPM = hours >= 12 ? 'PM' : 'AM';
    let formattedHours = hours % 12 === 0 ? 12 : hours % 12;
    let formattedTime = `${formattedHours}:${minutes.toString().padStart(2, '0')} ${amPM}`;
    return formattedTime
}

const combineDateTime = (node: ItineraryFlight, n: string, type: string) => {
    let requiredDate: string = ''
    let requiredTime: string = ''
    if (n === 'arrival') {
        requiredDate = node.connectionFlights?.length > 0 && type !== 'direct' ? node.connectionFlights[node.connectionFlights.length - 1].arrivalDate : node?.arrivalDate
        requiredTime = node.connectionFlights?.length > 0 && type !== 'direct' ? node.connectionFlights[node.connectionFlights.length - 1].arrivalTime : node?.arrivalTime
    }
    else if (n === 'departure') {
        requiredDate = node?.departDate
        requiredTime = node?.departTime
    }
    else if (n === 'connect' && type === 'connect1') {
        requiredDate = node.arrivalDate
        requiredTime = node.arrivalTime
    }
    else if (n === 'connect' && type === 'connect2') {
        requiredDate = node.departDate
        requiredTime = node?.departTime
    }

    const date = new Date(requiredDate)

    const [hour, minute] = Time(requiredTime).split(" ")[0].split(":");
    const isPM = Time(requiredTime).includes("PM");
    const zero = Time(requiredTime).includes("12")
    date.setHours(isPM && !zero ? parseInt(hour) + 12 : zero && !isPM ? parseInt(hour) - 12 : parseInt(hour), parseInt(minute), 0, 0);

    return date
};
export const handleDuration = (node: ItineraryFlight, n: string) => {
    let departTime = new Date(combineDateTime(node, 'departure', n))
    let arrivalTime = new Date(combineDateTime(node, 'arrival', n))

    let intialTimeZone = node?.flight?.departure?.timeZone
    let targetTimeZone = node?.connectionFlights && node?.connectionFlights?.length > 0 && n !== 'direct' ? node?.connectionFlights[node.connectionFlights.length - 1].flight?.arrival?.timeZone : node?.flight?.arrival?.timeZone

    const arrivalSpecificDateTime = DateTime.fromObject({
        year: parseInt(moment(arrivalTime).format('YYYY')),
        month: parseInt(moment(arrivalTime).format('M')),
        day: parseInt(moment(arrivalTime).format('D')),
        hour: parseInt(moment(arrivalTime).format('HH')),
        minute: parseInt(moment(arrivalTime).format('mm'))
    });
    const departureSpecificDateTime = DateTime.fromObject({
        year: parseInt(moment(departTime).format('YYYY')),
        month: parseInt(moment(departTime).format('M')),
        day: parseInt(moment(departTime).format('D')),
        hour: parseInt(moment(departTime).format('HH')),
        minute: parseInt(moment(departTime).format('mm'))
    });

    const requiredArrivalDateTimeZone = arrivalSpecificDateTime.setZone(targetTimeZone)
    const requiredDepartDateTimeZone = departureSpecificDateTime.setZone(intialTimeZone)

    let departTimeZone = departureSpecificDateTime.toString().split('000')[0].concat('000', requiredDepartDateTimeZone.toString().split('000')[1])
    let arrivalTimeZone = arrivalSpecificDateTime.toString().split('000')[0].concat('000', requiredArrivalDateTimeZone.toString().split('000')[1])

    let time1 = new Date(departTimeZone).getTime()
    let time2 = new Date(arrivalTimeZone).getTime()
    let diff = Math.abs(time2 - time1)
    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))
    if (minutes === 0)
        return `${hours} h travel`
    else {
        return `${hours} h ${minutes} min travel`
    }
}

export const handleConnectionDuration = (connect1: ItineraryFlight, connect2: ItineraryFlight, n: string) => {
    let time1 = new Date(combineDateTime(connect1, n, 'connect1')).getTime() / 1000
    let time2 = new Date(combineDateTime(connect2, n, 'connect2')).getTime() / 1000
    let diff = (time2 - time1) / 3600
    let temp = diff.toString().split('.')
    if (temp[0]) {
        let minutes = diff - parseInt(temp[0])
        minutes = Math.round(minutes * 60)
        return `${temp[0]} h ${minutes !== 0 ? `${minutes}min connection time` : 'connection time'}`
    }
    else {
        return `${diff} h connection time`
    }
}




